import { Box, ButtonNew } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { FlatList, RefreshControl, ScrollView } from 'react-native'
import { ShimmerView } from '../../comps/ShimmerView'
import { ListItemTxn } from '../../comps/TableComponent/ListRow'
import { TransactionType } from '../../data/models/Transactions'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getErrorState, getLoadingState, isMobile, tableConfig } from '../../util/util'

const SearchRecords = ({ onRefresh, refreshing }: any) => {
  const navigation = useNavigation()
  const {
    searchString,
    fetchTransaction,
    updateSelectedTxn,
    fetchTransactionDetailsOfPath,
    pagination,
    resetPagination,
    getTransactionsColumn,
    getTrxn,
    moreTxnAvailable,
    loadMoreTxnsSearch,
  } = useStores((store) => ({
    searchString: store.settings.metaData.searchString,
    fetchTransaction: store.transactions.fetchTransaction,
    updateSelectedTxn: store.transactions.updateSelectedTxn,
    fetchTransactionDetailsOfPath: store.fetchTransactionDetailsOfPath,
    pagination: store.transactions.pagination,
    resetPagination: store.transactions.resetPagination,
    getTransactionsColumn: store.transactions.getTransactionsColumnV3,
    getTrxn: store.transactions.getTransactionsV3,
    moreTxnAvailable: store.moreTxnAvailable,
    loadMoreTxnsSearch: store.loadMoreTxnsSearch,
  }))

  const [fetchTxnColumns, txnColumnHandler] = useLazyApiData(getTransactionsColumn)
  const [fetchTxn, fetchTxnHandler] = useLazyApiData(getTrxn)
  const apis = [txnColumnHandler, fetchTxnHandler]
  const loadingState = getLoadingState(apis)
  const errorState = getErrorState(apis)
  const canFetchMoreTxns = moreTxnAvailable(Routes.SEARCH)
  const isLarge = useIsLargeScreen()
  const isMobileDevice = isMobile(isLarge)

  const [isLoadingMore, setLoadMore] = useState(false)

  const getListData = (): TransactionType[] | any[] => {
    return fetchTransaction(tableConfig(Routes.TRANSACTIONS).tabletype, isMobileDevice)
  }

  const dataList = getListData()

  const handleItemPress = (item: any) => {
    // updateRecents(item?.id, searchFilterItem)
    updateSelectedTxn(item.id)
    navigation.navigate(Routes.TRANSACTIONS_DETAILS, { transactionId: item?.id, path: Routes.TRANSACTIONS })
  }

  useEffect(() => {
    if (!loadingState && isLoadingMore) {
      setLoadMore(false)
    }
  }, [isLoadingMore, loadingState])

  const onLoadMore = () => {
    setLoadMore(true)
    loadMoreTxnsSearch(fetchTxn, fetchTxnColumns)
  }

  const onFilterChanged = () => {
    resetPagination()
    fetchTransactionDetailsOfPath(fetchTxnColumns, fetchTxn, false, undefined, pagination)
  }

  if (refreshing) {
    return <ShimmerView type={Routes.TRANSACTIONS} />
  }

  const renderListFooterComponent = () => {
    if (dataList?.length > 0 && canFetchMoreTxns && !isLoadingMore) {
      return (
        <Box pv={24} align={'center'} alignSelf={'center'}>
          <ButtonNew
            title={'Show more'}
            onPress={onLoadMore}
            type={'secondary'}
            underlayColor="TRANSPARENT"
            titleColor={'PRIMARY'}
            paddingHorizontal={24}
            paddingVertical={8}
            borderColor={'PRIMARY'}
            isRaceTrack
          />
        </Box>
      )
    }

    if (isLoadingMore) {
      return <ShimmerView type={Routes.TRANSACTIONS} itemCount={2} />
    }
    return <Box h={80} />
  }

  const refreshControl = <RefreshControl refreshing={false} onRefresh={onRefresh} />
  return (
    <>
      <ScrollView refreshControl={refreshControl}>
        <FlatList
          ListFooterComponent={renderListFooterComponent}
          data={getListData()} renderItem={({ item, index }) => {
            return (
              <ListItemTxn index={index} key={index} item={item} onPress={() => handleItemPress(item)} disabled={false} />
            )
          }} />
      </ScrollView>
    </>
  )
}

export { SearchRecords }
